<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <AlertErrorMsg
        ref="alert"
        :title="errorMessage"
        class="page-alert-error"
      />
      <HeaderRegistered :return-path="returnPath" :sub-title="caseTitle" />
      <main class="main">
        <section class="case-export-section">
          <div
            class="top-bar"
            :class="{ active: isAdvancedFilterApplied || isAdvancedFilter}"
            :style="{ justifyContent: isAdvancedFilterApplied ? 'flex-end' : 'space-between' }"
          >
            <CustomSelect
              v-show="!isAdvancedFilter && !isAdvancedFilterApplied"
              v-model="currentTab"
              :options="tabOptions"
              :default="tabOptions[1].name"
              type-select="filterUser"
              class="tab-select"
              @input="onTabChange"
            />
            <div
              class="settings-wrapper"
              :style="{
                flexDirection: isAdvancedFilter ? 'row' : 'column',
                width: isAdvancedFilter ? '88%' : '50%',
              }"
            >
              <template v-if="isAdvancedFilterApplied || isAdvancedFilter">
                <div v-if="isAdvancedFilter" class="filter-types">
                  <button
                    :class="{selected: !filterTypeSaved}"
                    class="filter-type"
                    @click="filterTypeSaved = false"
                  >
                    Default
                  </button>
                  <button
                    :class="{selected: filterTypeSaved}"
                    class="filter-type"
                    @click="filterTypeSaved = true"
                  >
                    Saved
                  </button>
                </div>
              </template>
              <div class="advanced-change-button-wrapper">
                <button
                  v-if="stringifiedRules"
                  class="advanced-change-button add-to-favorites"
                  @click="openSaveFilterPatternPopup"
                >
                  <BlueBookmarkIcon1623 />
                  <span>Add To Favorites</span>
                </button>
                <button
                  v-if="isAdvancedFilterApplied || isAdvancedFilter"
                  :disabled="!isAdvancedFilterApplied"
                  class="reset-filters"
                  @click="resetFilters"
                >
                  <OrangeCloseIcon28 />
                  Reset Filters
                </button>
                <button
                  v-if="currentTab !== CASE_EXPORT_TABS.allCase"
                  class="advanced-change-button"
                  @click="changeFilterView"
                >
                  <BlueFilterIcon25 :class="{'advanced-mode': isAdvancedFilter}" />
                  <span>Advanced</span>
                  <GreyArrowDown17 :class="{'advanced-mode-arrow': isAdvancedFilter}" />
                </button>
                <button
                  v-if="!isAdvancedFilter"
                  :disabled="!hasPermission(['export_case']) || timeRemaining > 0"
                  class="btn"
                  style="height: 40px"
                  @click="openExportCasePopup"
                >
                  Export Data
                </button>
              </div>
              <div v-if="!isAdvancedFilter" :style="{opacity: timeRemaining > 0 ? '1' : '0'}" class="timer">
                <span>Time remaining for another case export request: </span>{{ timeRemaining }} sec.
              </div>
            </div>
            <div v-if="isLoaded" v-show="isAdvancedFilter" class="advanced-filter-wrap">
              <SavedFilters
                v-if="filterTypeSaved"
                @attachFilter="attachFilter"
                @backToDefault="filterTypeSaved = false"
              />
              <div v-else class="control-section">
                <div class="col-lg-12 querybuilder-control">
                  <ejs-querybuilder
                    ref="querybuilder"
                    :data-source="dataSource"
                    :max-group-count="100"
                    :rule="importRules"
                    @change="ruleChanged"
                  >
                    <e-columns>
                      <e-column
                        v-for="(col, idx) in columns"
                        :key="idx"
                        :field="col.field"
                        :label="col.label"
                        :type="col.type"
                        :template="col.template"
                        :operators="col.operators"
                        format="dd/MM/yyyy"
                      />
                    </e-columns>
                  </ejs-querybuilder>
                  <div class="advanced-btn-wrapper">
                    <button class="btn btn-apply" type="button" @click="addRule">
                      + Add Rule
                    </button>
                    <button class="btn btn-apply" type="button" @click="addGroup">
                      + Add Group
                    </button>
                    <button
                      :disabled="emptyRule"
                      class="btn btn-apply"
                      type="button"
                      @click="filter(false)"
                    >
                      Apply
                    </button>
                    <span>{{ resultCount }} matches</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isAdvancedFilterApplied && !isAdvancedFilter" class="advanced-filter-wrap">
              <div class="filter-tags-close">
                <button class="advanced-change-button" @click="isOpenedFilterList = !isOpenedFilterList">
                  <span>{{ isOpenedFilterList ? 'Close' : 'Show' }} Applied Filters</span>
                  <GreyArrowDown17 :class="{'advanced-mode-arrow': isOpenedFilterList}" />
                </button>
              </div>

              <ul v-show="isOpenedFilterList" class="control-tags">
                <li
                  v-for="tag of filteredTags"
                  :key="tag.id"
                  :class="{ 'removed': tag.removed }"
                  class="filter-tag"
                >
                  <!--                  <button type="button" @click="removeFilter(tag)">-->
                  <!--                    <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">-->
                  <!--                      <path-->
                  <!--                        d="M14 2.3335C7.54833 2.3335 2.33333 7.5485 2.33333 14.0002C2.33333 20.4518 7.54833 25.6668 14 25.6668C20.4517 25.6668 25.6667 20.4518 25.6667 14.0002C25.6667 7.5485 20.4517 2.3335 14 2.3335ZM19.8333 18.1885L18.1883 19.8335L14 15.6452L9.81166 19.8335L8.16666 18.1885L12.355 14.0002L8.16666 9.81183L9.81166 8.16683L14 12.3552L18.1883 8.16683L19.8333 9.81183L15.645 14.0002L19.8333 18.1885Z"-->
                  <!--                        data-v-1f88d880=""-->
                  <!--                        fill="#D7DCE5"-->
                  <!--                      />-->
                  <!--                    </svg>-->
                  <!--                  </button>-->

                  <strong>{{ tag.label | filteringLabel }}</strong>:&nbsp;
                  <span>{{ tag.initialValue || tag.value }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="holder-table">
            <h1>Export History</h1>
            <table cellpadding="0" cellspacing="0" border="0">
              <TableHeader>
                <tr>
                  <th>
                    <div class="table-header-box">
                      <DateIcon16 />
                      <span class="header-table-text">Date</span>
                    </div>
                  </th>
                  <th class="w-300">
                    <div class="table-header-box">
                      <UserIcon />
                      <span class="header-table-text">User Name</span>
                    </div>
                  </th>

                  <th>
                    <div class="table-header-box">
                      <CaseIcon />
                      <span class="header-table-text">Case name</span>
                    </div>
                  </th>

                  <th>
                    <div class="table-header-box">
                      <CaseIcon />
                      <span class="header-table-text">format</span>
                    </div>
                  </th>

                  <th>
                    <div :id="`sort_export_in_case_${caseId}_by_status`" class="table-header-box">
                      <WhiteClockIcon16 />
                      <span class="header-table-text">status</span>
                    </div>
                  </th>
                  <th />
                </tr>
              </TableHeader>
              <CaseExportItem
                :case-export-list="caseExportList"
                @downloadItem="downloadItem"
              />
              <div v-if="loadFlag" class="loader-bg">
                <div class="loader-p" />
              </div>
            </table>
            <pagination
              v-if="caseExportList && caseExportList.length && count !== 1"
              v-model="page"
              :total-pages="count"
              :link-gen="linkGen"
            />
          </div>
          <SaveFilterPattern
            ref="saveFilterPattern"
            @saveFilterPattern="saveFilterPattern"
          />
        </section>
      </main>
    </div>
    <SuccessPopup
      ref="successPopup"
      :text="'Case has been successfully exported. You can find the download link in the export history table'"
    />
    <ExportPopup
      ref="exportPopup"
      :is-filters-applied="isAdvancedFilterApplied"
      :is-messages-export="currentTab === CASE_EXPORT_TABS.messages"
      @export="actionExportCase"
    />
    <CommonDialog
      ref="progressDialog"
      btn-name="Hide"
      width="360"
      @closed="onExportHidden"
    >
      <h2 class="dialog-message-title">
        Exporting case
      </h2>
      <div class="dialog-create-description" style="display:block; font-size: 14px;">
        <p>The case is being exported.</p>
        <p>Click the “Hide” button and we will notify you when the export is complete.</p>
      </div>
      <CircularLoader />
    </CommonDialog>
  </div>
</template>

<script>
import hasPermission from '../../../utils/permission';
import CaseIcon from '../../icons/CaseIcon';
import UserIcon from '../../icons/UserIcon';
import AlertErrorMsg from '../../profile/AlertErrorMsg';
import HeaderRegistered from '../../layout/HeaderRegistered';
import TableHeader from '../../table/TableHeader';
import CaseExportItem from './CaseExportItem';
import Pagination from '@/components/common/Pagination.vue';
import CommonDialog from '@/components/popups/CommonDialog.vue';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import SavedFilters from '@/components/cases/case-messages/SavedFilters.vue';
import SaveFilterPattern from '@/components/popups/SaveFilterPattern.vue';
import {createElement, getComponent} from '@syncfusion/ej2-base';
import {AutoComplete, CheckBoxSelection, DropDownList, MultiSelect} from '@syncfusion/ej2-dropdowns';
import {Query} from '@syncfusion/ej2-data';
import Vue from 'vue';
import {
  ColumnDirective,
  ColumnsDirective,
  QueryBuilderComponent,
  QueryBuilderPlugin
} from '@syncfusion/ej2-vue-querybuilder';
import {DateRangePicker} from '@syncfusion/ej2-calendars';
import moment from 'moment/moment';
import ExportPopup from '@/components/popups/ExportPopup.vue';
import debounce from '@/mixins/debounce';
import {CASE_EXPORT_TABS} from '@/constants/const';
import streamReader from '@/mixins/streamReader';
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import SuccessPopup from '@/components/popups/SuccessPopup.vue';
import errorHandler from '@/mixins/errorHandler';
import {mapActions} from 'vuex';
import BlueBookmarkIcon1623 from '@/components/icons/BlueBookmarkIcon1623.vue';
import OrangeCloseIcon28 from '@/components/icons/OrangeCloseIcon28.vue';
import GreyArrowDown17 from '@/components/icons/GreyArrowDown17.vue';
import BlueFilterIcon25 from '@/components/icons/BlueFilterIcon25.vue';
import DateIcon16 from '@/components/icons/DateIcon16.vue';
import WhiteClockIcon16 from '@/components/icons/WhiteClockIcon16.vue';
import CircularLoader from '@/components/loader/CircularLoader.vue';

MultiSelect.Inject(CheckBoxSelection);

Vue.use(QueryBuilderPlugin);

const types = ['value', 'deleteRule', 'deleteGroup', 'condition'];

export default {
  name: 'CaseExport',
  components: {
    CircularLoader,
    WhiteClockIcon16,
    DateIcon16,
    BlueFilterIcon25, GreyArrowDown17,
    OrangeCloseIcon28,
    BlueBookmarkIcon1623,
    SuccessPopup,
    CustomSelect,
    ExportPopup,
    SaveFilterPattern,
    SavedFilters,
    CommonDialog,
    Pagination,
    CaseIcon,
    UserIcon,
    CaseExportItem,
    TableHeader,
    HeaderRegistered,
    AlertErrorMsg,
    'ejs-querybuilder': QueryBuilderComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
  },
  filters: {
    filteringLabel(label) {
      let labelsList = label.split(' ');
      labelsList = labelsList.map(phrase => {
        if (phrase === 'a' || phrase === 'for' || phrase === 'Search' || phrase === 'the') {
          return;
        }
        return phrase;
      });

      return labelsList.join(' ');
    }
  },
  mixins: [capitalizeFirstLetter, debounce, streamReader, errorHandler],
  data() {
    let isOperators = ['is', 'not_is'];
    let containOperators = ['contain', 'not_contain'];

    return {
      CASE_EXPORT_TABS,
      currentTab: CASE_EXPORT_TABS.messages,
      tabOptions: [
        {name: 'All case', id: 'all_case'},
        {name: 'Mobile chats', id: 'messages'},
        {name: 'Emails', id: 'emails'},
        {name: 'Media', id: 'media'},
        {name: 'Call Logs', id: 'calls'},
        {name: 'Contacts', id: 'contacts'},
        {name: 'Apps', id: 'apps'},
      ],

      // ADVANCED FILTER
      isAdvancedFilterApplied: false,
      isLoaded: true,
      filterTypeSaved: false,
      isAdvancedFilter: false,
      clientId: '',
      isOpenedFilterList: true,
      filteredTags: [],
      dataSource: [],
      initialData: [],
      emptyRule: true,
      stringifiedRules: '',
      resultCount: 0,
      columns: [],

      isRequired: {isRequired: true},
      defaultImportRules: {},
      importRules: {},
      dateTemplate: {
        create: () => {
          return createElement('input', {attrs: {'type': 'text'}});
        },
        destroy: (args) => {
          let daterangepicker = getComponent(document.getElementById(args.elementId), 'daterangepicker');
          if (daterangepicker)
            daterangepicker.destroy();
        },
        write: (args) => {
          let daterangepicker = new DateRangePicker({
            placeholder: 'Select date range',
            disabled: true,
            change: (e) => {
              this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element);
            },
          });

          if (args.values) {
            daterangepicker.startDate = new Date(this.formatDate(args.values[0]));
            daterangepicker.endDate = new Date(this.formatDate(args.values[1]));
          }

          daterangepicker.appendTo('#' + args.elements.id);
        }
      },
      defaultTemplate: {
        create: () => {
          return createElement('input', {attrs: {'type': 'text'}});
        },
        destroy: (args) => {
          let multiselect = getComponent(document.getElementById(args.elementId), 'multiselect');
          if (multiselect)
            multiselect.destroy();
          let autoComplete = getComponent(document.getElementById(args.elementId), 'autocomplete');
          if (autoComplete)
            autoComplete.destroy();
        },
        write: (args) => {
          let ds = [];

          this.initialData.forEach(item => {
            if (item.fieldName === args.field && item.values) {
              item.values.forEach(el => {
                let elName = this.capitalizeFirstLetter(el);
                ds.push({id: el, value: elName});
              });
            }
          });

          if (containOperators.indexOf(args.operator) > -1) {
            let autoCompleteObj = new AutoComplete({
              dataSource: ds,
              fields: {text: 'value', value: 'id'},
              placeholder: `Find a ${this.stringModify(args.field)}`,
              highlight: true,
              itemTemplate: '<span class=\'filtering-name\'>${id}</span>',
              change: (e) => {
                let name = '';

                if (e.itemData) {
                  name = e.itemData.id;
                }

                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(name, e.element);
              }
            });
            autoCompleteObj.appendTo('#' + args.elements.id);
          } else if (isOperators.indexOf(args.operator) > -1) {
            let dropDownObj = new DropDownList({
              dataSource: ds,
              fields: {text: 'value', value: 'id'},
              value: args.values,
              change: (e) => {
                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element);
              }
            });
            dropDownObj.appendTo('#' + args.elements.id);
          } else {
            let multiSelectObj = new MultiSelect({
              dataSource: ds,
              value: args.values,
              fields: {text: 'value', value: 'id'},
              mode: 'CheckBox',
              placeholder: `Select ${this.stringModify(args.field)}`,
              change: (e) => {
                this.$refs.querybuilder.$el.ej2_instances[0].notifyChange(e.value, e.element);
              },
              filtering: function (e) {
                let query = new Query();
                //frame the query based on search string with filter type.
                query = (e.text != '') ? query.where('value', 'startswith', e.text, true) : query;
                //pass the filter data source, filter query to updateData method.
                e.updateData(ds, query);
              }
            });
            multiSelectObj.appendTo('#' + args.elements.id);
            if (args.values) {
              multiSelectObj.change(multiSelectObj);
            }
          }
        }
      },

      returnPath: true,
      caseId: this.$route.params.slug,
      caseExportList: [],
      loadFlag: false,
      errorMessage: '',
      caseTitle: '',
      page: 1,
      size: 10,
      count: 0,
      pageSize: 2,
      queryFilterParams: null,
      timeRemaining: 0,
      intervalId: null,
      disabledFiltersId: [],
      defaultQueryFilterParams: [],
      msgFilters: null,
    };
  },
  computed: {
    subTitle() {
      return ` Case ${this.caseId}`;
    },
  },
  watch: {
    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.page = newVal;
          this.getCaseExport();
        } else {
          this.page = 1;
        }
      }
    },
    currentTab() {
      if (this.currentTab !== CASE_EXPORT_TABS.allCase) {
        this.getCaseExportSettings();
      }
      this.getCaseExport();
    }
  },
  mounted() {
    this.page = this.$route.query.page || 1;
    this.caseTitle = localStorage.getItem('title');
    this.$store.dispatch('profile/getPermissionPerCase', {caseId: this.caseId});

    this.resetExportStatus();

    this.getCaseExport();
    this.getCaseExportSettings();
    this.checkTimer();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions('appState', ['startExport', 'completeExport', 'hideExport', 'resetExportStatus']),
    onTabChange(selectedId) {
      this.currentTab = selectedId;
    },

    stringModify(str) {
      return str.split('').map((letter, idx) => {
        return letter.toUpperCase() === letter
          ? `${idx !== 0 ? ' ' : ''}${letter.toLowerCase()}`
          : letter;
      }).join('');
    },

    // ADVANCED FILTERING

    openSaveFilterPatternPopup() {
      this.$refs.saveFilterPattern.openPopups();
    },
    async saveFilterPattern(filterName) {
      await this.$load(async () => {
        try {
          await this.$api.cases.saveFilterPattern(this.caseId, {
            name: filterName,
            value: this.stringifiedRules,
          });
          this.stringifiedRules = '';
        } catch (error) {
          this.handleResponseError(error);
          this.$emit('show-error', error.response.data.errors.message.toString());
        }
      });
    },
    filter(getResultCount) {
      if (!getResultCount) {
        this.stringifiedRules = JSON.stringify({
          clientId: this.clientId,
          rules: this.$refs.querybuilder.ej2Instances.rule.properties
        });

        localStorage.setItem('rules', this.stringifiedRules);
        this.queryFilterParams = this.getQueryParams(true);
      }

      this.filtersAmountApplied = this.queryFilterParams.reduce((a, b) => a + b.rules.length, 0);
      this.queryFilterParams = this.queryFilterParams.filter(param => param.rules.length);

      this.queryFilterParams.forEach(item => {
        if (item.rules.length) {
          item.rules.forEach((el, i) => {
            if (!el.value) {
              item.rules.splice(i, 1);
              return;
            }
            if (el.field === 'date') {

              if (el.value.length) {
                let dateObj = {
                  field: 'date',
                  label: 'Date',
                  operator: 'gth',
                  type: 'date',
                  value: ''
                };
                let dateFromObj = Object.assign({}, dateObj);
                let dateToObj = Object.assign({}, dateObj);
                let dateFrom = el.value[0].split('/');
                let dateTo = el.value[1].split('/');
                let dateFromTime = `${dateFrom[2]}-${dateFrom[1]}-${dateFrom[0]}`;
                let dateToTime = `${dateTo[2]}-${dateTo[1]}-${dateTo[0]}`;
                dateFrom = moment(dateFromTime).valueOf();
                dateTo = moment(dateToTime).endOf('day').valueOf();
                dateFromObj.value = dateFrom;
                dateFromObj.operator = 'gth';
                dateToObj.value = dateTo;
                dateToObj.operator = 'lth';
                dateFromObj.initialValue = dateFromTime;
                dateToObj.initialValue = dateToTime;
                item.rules.push(dateFromObj);
                item.rules.push(dateToObj);
                item.rules.splice(i, 1);
              }
            }
          });
        }
      });

      if (getResultCount) {
        this.getCountForExport();
      } else {
        this.filteredTags = [];
        this.isAdvancedFilterApplied = true;
        this.isAdvancedFilter = false;
        this.defaultQueryFilterParams = this.queryFilterParams;
        this.filterTags(this.queryFilterParams);
      }
    },
    removeFilter(disabledTag) {
      let areThereRules = false;

      if (disabledTag.removed) {
        const disabledFilterId = this.disabledFiltersId.findIndex(el => el === disabledTag.id);

        this.disabledFiltersId.splice(disabledFilterId, 1);
      } else {
        this.disabledFiltersId.push(disabledTag.id);
      }

      disabledTag.removed = !disabledTag.removed;

      this.queryFilterParams = this.defaultQueryFilterParams.map(parameter => {
        const rules = parameter.rules.filter(rule => {
          for (let i = 0; i < this.disabledFiltersId.length; i++) {
            if (rule.id === this.disabledFiltersId[i]) {
              return false;
            }
          }

          return true;
        });

        if (rules.length) {
          areThereRules = true;
        }

        return {
          ...parameter,
          rules: rules,
        };
      }).filter(queryParam => !!queryParam.rules.length);

      if (areThereRules) {
        this.debounce(() => this.filter(false), 1000);
      } else {
        this.resetFilters();
      }
    },

    // QUERY BUILDER

    changedQueryBuilder(e) {
      if (e.type === 'insertRule') {
        return;
      }

      this.queryFilterParams = this.getQueryParams();

      if (this.isValidQueryFilterParams) {
        this.resultCount = 0;
        return;
      }

      if (e.type === 'deleteGroup') {
        const groupID = e.groupID.split('group').join('');

        this.queryFilterParams.splice(groupID, 1);
      }

      if (types.some(type => type === e.type)) {
        this.filter(true);
      }
    },
    checkIsNestedRulesNotEmpty(rules) {
      return rules.every(rule => {
        if (rule.value === undefined) return true;

        return rule.rules
          ? this.checkIsNestedRulesNotEmpty(rule.rules)
          : rule.value && rule.value.length;
      });
    },

    // RULES & GROUPS
    addRule(_, rule) {
      let count = Object.keys(this.$refs.querybuilder.ej2Instances.levelColl)[Object.keys(this.$refs.querybuilder.ej2Instances.levelColl).length - 1].slice(-1);
      this.$refs.querybuilder.ej2Instances.addRules([rule || {field: 'custodian'}], `group${count}`);
    },
    addGroup(_, group) {
      let count = Object.keys(this.$refs.querybuilder.ej2Instances.levelColl)[Object.keys(this.$refs.querybuilder.ej2Instances.levelColl).length - 1].slice(-1);
      this.$refs.querybuilder.ej2Instances.addGroups([group || this.defaultImportRules], `group${count}`);
    },
    setSavedRules(rules) {
      rules.forEach(rule => {
        if (rule.rules && rule.rules.length) {
          this.addGroup(false, {'condition': rule.condition || 'and', 'rules': [{}]});
          this.setSavedRules(rule.rules);
        } else if (rule.value) {
          this.addRule(false, rule);
        }
      });
    },
    setParsedRules(parsedRules) {
      this.importRules = {};
      this.isAdvancedFilterApplied = true;

      setTimeout(() => {
        const {rules} = parsedRules.rules;
        const lastRuleRules = rules[rules.length - 1].rules;

        this.setSavedRules(!lastRuleRules || lastRuleRules && lastRuleRules.length ? rules : rules.reverse());
        this.queryFilterParams = this.getQueryParams(true);

        this.filter(true);
        this.filter();
      }, 1000);
    },
    ruleChanged(event) {
      const rules = [];

      this.$refs.querybuilder.ej2Instances.rule.properties.rules.forEach(rule => {
        if (rule.rules) {
          if (!rule.rules.length) {
            return;
          }

          rules.push(this.checkIsNestedRulesNotEmpty(rule.rules));
          return;
        }

        rules.push(rule.value && !!rule.value.length);
      });

      this.emptyRule = rules.some(rule => rule !== undefined && !rule);

      if (!this.emptyRule || (!this.emptyRule && event.type === 'condition')) {
        this.debounce(this.changedQueryBuilder, 1000, event);
      }
    },

    async attachFilter(filterId) {
      await this.$load(async () => {
        const filter = await this.$api.cases.getFilterPattern(this.caseId, filterId);
        this.filterTypeSaved = false;
        this.setParsedRules(JSON.parse(filter.data.body.value));
      });
    },
    changeFilterView() {
      this.isAdvancedFilter = !this.isAdvancedFilter;
    },
    reset() {
      this.$refs.querybuilder.ej2Instances.reset();
      this.$refs.querybuilder.ej2Instances.levelColl = [];
    },
    resetFilters() {
      localStorage.removeItem('rules');
      this.stringifiedRules = '';
      this.isAdvancedFilter = true;
      this.isAdvancedFilterApplied = false;
      this.filtersAmountApplied = 0;
      this.MessagesChatPage = 0;
      this.queryFilterParams = null;
      this.filteredTags = [];
      this.isOpenedFilterList = true;
      this.resultCount = 0;
      this.reset();
      this.$refs.querybuilder.ej2Instances.setRules(this.defaultImportRules);
      this.filtersAppliedCount = 0;
    },

    hasPermission,
    linkGen(pageNum) {
      return {
        path: `/cases/${this.caseId}/export`,
        query: {page: pageNum}
      };
    },
    downloadItem(item) {
      window.$axiosFiles.get(`/cases/${this.caseId || this.$route.params.case_id}/export/${item.exportId}/download`, {
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.key.toString().substring(item.key.toString().lastIndexOf('/') + 1));
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          this.handleResponseError(error);
        });
    },
    openExportCasePopup() {
      if (this.currentTab === CASE_EXPORT_TABS.allCase) {
        this.exportV3();
      } else {
        this.$refs.exportPopup.openPopups();
      }
    },
    actionExportCase(format, config, applyTimeframes = false) {
      if (this.currentTab === CASE_EXPORT_TABS.messages) {
        if (format === 'rsmf' || format === 'csv') {
          this.exportV1(format, applyTimeframes);
        } else {
          this.exportWithFilters(format, config, applyTimeframes);
        }
      } else if (this.currentTab === CASE_EXPORT_TABS.allCase) {
        this.exportV3();
      } else {
        this.exportFilteredCaseItems(format);
      }
    },
    onExportHidden() {
      this.startExport(this.caseId);
      this.hideExport();
    },
    handleStreamResult(showPopup = true) {
      if (this.dialog.status.toLowerCase().includes('error')) {
        this.errorMessage = this.dialog.text;
        this.$emit('show-error', this.errorMessage);
        if (this.$refs.alert) {
          this.$refs.alert.showAlert();
        }
        this.completeExport();
      } else {
        this.dialog.text = 'Starting...';
        this.dialog.status = '';
        this.progressPercentage = 0;

        const caseName = this.caseTitle || localStorage.getItem('title');

        if (this.$refs.successPopup && showPopup) {
          this.$refs.successPopup.openPopup();
          this.completeExport();
        } else {
          this.completeExport({isSuccessful: true, caseName});
        }
      }
    },
    exportV3() {
      this.$load(async () => {
        this.startTimer();
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.caseExport.exportCaseV3(this.caseId);

        if (!response.ok) {
          this.errorMessage = 'Export error. Status: ' + response.status;
          this.$refs.progressDialog.closePopups();
          this.$refs.alert.showAlert();
          return;
        }

        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        await this.getCaseExport();

        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      }, (error) => {
        if (error.response) {
          this.errorMessage = error.response.data.errors.message[0];
        } else {
          this.errorMessage = error.data.errors.message[0];
        }
        this.$refs.alert.showAlert();
      });
    },
    exportFilteredCaseItems(format) {
      this.$load(async () => {
        this.startTimer();
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.caseExport.exportCaseItems(
          this.caseId,
          this.currentTab,
          format,
          this.getMappedRules(),
        );

        if (!response.ok) {
          this.errorMessage = 'Export error. Status: ' + response.status;
          this.$refs.progressDialog.closePopups();
          this.$refs.alert.showAlert();
          return;
        }

        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        await this.getCaseExport();

        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    exportWithFilters(format, config, applyTimeframes) {
      this.$load(async () => {
        this.startTimer();
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.caseExport.exportCaseWithFilters(
          this.caseId,
          format,
          applyTimeframes,
          {
            exportRequest: this.getMappedRules(),
            config: config,
          });

        if (!response.ok) {
          this.errorMessage = 'Export error. Status: ' + response.status;
          this.$refs.progressDialog.closePopups();
          this.$refs.alert.showAlert();
          return;
        }

        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        await this.getCaseExport();

        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    exportV1(format, applyTimeframes) {
      this.$load(async () => {
        this.startTimer();
        this.$refs.progressDialog.openPopups();

        const response = await this.$api.cases.exportCases(this.caseId, format, applyTimeframes);

        if (!response.ok) {
          this.errorMessage = 'Export error. Status: ' + response.status;
          this.$refs.progressDialog.closePopups();
          this.$refs.alert.showAlert();
          return;
        }

        // eslint-disable-next-line no-undef
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        await this.processStreamData(reader, 25);
        this.handleStreamResult();

        await this.getCaseExport();

        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    getCaseExport() {
      this.$load(async () => {
        await this.$api.cases.getExportCases({
          caseId: this.caseId,
          page: this.page,
          size: this.size,
          type: this.currentTab === CASE_EXPORT_TABS.messages ? 'chats' : this.currentTab,
        }).then((res) => {
          this.caseExportList = res.data.body.content;
          this.count = res.data.body.totalPages;
          this.pageSize = res.data.body.size;
        }, (error) => {
          this.handleResponseError(error);
        });
        setTimeout(() => {
          this.loadFlag = false;
        }, 1000);
      });
    },
    startTimer() {
      const duration = 60;
      const endTime = Date.now() + duration * 1000;

      localStorage.setItem('endTime', endTime);

      this.timeRemaining = duration;
      this.startCountdown();
    },
    startCountdown() {
      clearInterval(this.intervalId);

      this.intervalId = setInterval(() => {
        const endTime = localStorage.getItem('endTime');
        if (endTime) {
          const remaining = Math.ceil((endTime - Date.now()) / 1000);

          if (remaining > 0) {
            this.timeRemaining = remaining;
          } else {
            this.timeRemaining = 0;
            clearInterval(this.intervalId);
          }
        } else {
          this.timeRemaining = 0;
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    checkTimer() {
      const endTime = localStorage.getItem('endTime');
      if (endTime) {
        const remaining = Math.ceil((endTime - Date.now()) / 1000);

        if (remaining > 0) {
          this.timeRemaining = remaining;
          this.startCountdown();
        } else {
          this.timeRemaining = 0;
          localStorage.removeItem('endTime');
        }
      }
    },
    getCaseExportSettings() {
      this.isLoaded = false;
      this.$load(async () => {
        const res = await this.$api.caseExport.getSettingExportCase(
          this.caseId,
          this.currentTab,
          {emails: [], chats: [], phones: []}
        );
        this.initialData = res.data.body;
        this.columns = this.buildColumnsFromResponse(res.data.body);
        this.importRules = this.buildDefaultRules(res.data.body);
        this.defaultImportRules = this.buildDefaultRules(res.data.body);
        this.isLoaded = true;
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    buildColumnsFromResponse(responseBody) {
      return responseBody.map(item => {
        const isDateField = item.fieldName === 'date';
        return {
          field: item.fieldName,
          label: item.viewName,
          type: isDateField ? 'date' : 'string',
          template: isDateField ? this.dateTemplate : this.defaultTemplate,
          operators: item.operators.map(op => this.mapOperator(op))
        };
      });
    },
    buildDefaultRules(responseBody) {
      if (!responseBody || !responseBody.length) {
        return {condition: 'and', rules: []};
      }

      const rules = [{},];
      responseBody.slice(0, 2).forEach(item => {
        rules.push({
          field: item.fieldName,
          operator: item.operators[0] || '',
          key: item.operators[0] || '',
          type: item.fieldName === 'date' ? 'date' : 'string',
          label: item.viewName
        });
      });
      return {condition: 'and', rules};
    },
    mapOperator(op) {
      switch (op) {
        case 'is':
          return {value: 'is', key: 'is'};
        case 'is_not':
          return {value: 'is_not', key: 'is not'};
        case 'contain':
          return {value: 'contain', key: 'contain'};
        case 'not_contain':
          return {value: 'not_contain', key: 'not contain'};
        case 'in':
          return {value: 'in', key: 'in'};
        case 'not_in':
          return {value: 'not_in', key: 'not in'};
        case 'gth':
          return {value: 'gth', key: '>'};
        case 'lth':
          return {value: 'lth', key: '<'};
        default:
          return {value: op, key: op};
      }
    },
    getCountForExport() {
      this.$load(async () => {
        const res = await this.$api.caseExport.getCountFindingForExport(
          this.caseId,
          this.currentTab,
          this.getMappedRules(),
        );
        this.resultCount = res.data.body.count;
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    getQueryParams(setId = false) {
      if (this.$refs.querybuilder) {
        this.msgFilters = this.$refs.querybuilder.ej2Instances.getValidRules(this.$refs.querybuilder.ej2Instances.rule);
        return this.flatten(this.msgFilters, setId);
      }
    },
    flattenRules(rootRule) {
      if (!this.isCondition(rootRule) || !this.hasRuleset(rootRule)) return;

      const flat = (currentCondition) => {
        if (!this.hasRuleset(currentCondition)) return;

        // Filtering current ruleset to find inner conditions with non-empty rulesets;
        const nestedConditions = currentCondition.rules.filter(
          (item) => this.isCondition(item) && this.hasRuleset(item)
        );

        return [
          {
            ...currentCondition,
            // We exclude inner conditions from the ruleset and leave only the descriptions;
            rules: currentCondition.rules.filter((item) => !this.isCondition(item)),
          },
          ...nestedConditions.reduce(
            // We recursively call this function with all of the nested conditions;
            (acc, condition) => [...acc, ...flat(condition)],
            []
          ),
        ];
      };

      return flat(rootRule);
    },
    flatten(conditionsResult, setId) {
      let conditionsResultArray = this.flattenRules(conditionsResult);

      conditionsResultArray ? conditionsResultArray.forEach((item) => {
        if (item.condition === null) {
          item.condition = 'and';
        }
        if (item.rules.length) {
          item.rules.forEach((rule) => {
            if (setId) {
              rule.id = Math.random().toString(36).substr(2, 9);
            }
            if (rule.field !== 'date') {
              if (Array.isArray(rule.value)) {
                rule.value = rule.value.join(';');
              }
            }
          });
        }
      }) : [];

      return conditionsResultArray;
    },
    isCondition(item) {
      return item.condition !== undefined;
    },
    hasRuleset(condition) {
      return !!condition.rules && !!condition.rules.length;
    },
    formatDate(date) {
      const initial = date.split(/\//);

      return [initial[1], initial[0], initial[2]].join('/');
    },
    filterTags(rules) {
      rules.forEach(rule => {
        rule.rules ? this.filterTags(rule.rules) : this.filteredTags.push(rule);
      });
    },
    getMappedRules() {
      if (!this.queryFilterParams) {
        return [];
      }
      const mappedRules = this.queryFilterParams.flatMap(queryParam => {
        return queryParam.rules.map(rule => {
          return {
            field: rule.field,
            operator: rule.operator,
            value: rule.value,
          };
        });
      });
      const isRulesPresent = mappedRules.filter(rule => rule.value !== null).length > 0;
      return isRulesPresent ? mappedRules : [];
    }
  },
};
</script>

<style scoped lang="scss">
.case-export-section {
  padding: 90px 55px 24px 35px;
  min-height: 100vh;
  position: relative;

  .active {
    box-shadow: 0 4px 10px rgba(77, 106, 147, 0.15);
  }

  .top-bar {
    position: absolute;
    top: 10px;
    right: 55px;
    left: 23px;
    padding: 28px 0 28px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    z-index: 10;
    background-color: #fff;

    .tab-select {
      max-width: 215px;
      width: 100%;
      align-self: flex-start;
    }

    .tab-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 700px;
      min-height: 35px;
      margin-right: 20px;
      border-radius: 79px;
      border: 1px solid var(--case-btn-border-color);

      .tab-btn {
        margin: -1px 0 -1px 0;
        width: 50%;
        max-height: 35px;
        padding: 10px 30px;
        border: 1px solid transparent;
        outline: none;
        background-color: transparent;
        border-radius: 79px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: row;
        transition: 0.3s all;
      }

      .tab-btn.active {
        border-color: var(--accent-color);
      }

      .tab-btn-text {
        display: block;
        font-size: 14px;
        font-weight: 600;
        line-height: 14px;
        color: var(--light-gray);
        transition: 0.3s all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .tab-btn.active .tab-btn-text,
      .tab-btn:hover .tab-btn-text {
        color: var(--accent-color);
      }
    }

    .case-action-btn-wrap {

      .format-choose-wrapper {
        display: flex;
        flex-direction: column;
        width: 195px;
        margin-right: 16px;
      }

      .format-choose-text {
        font-size: 14px;
        font-weight: 700;
        color: var(--secondary-black-color);
        margin-bottom: 9px;
      }

      .btn {
        align-self: flex-end;
      }
    }

    .settings-wrapper {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .filter-types {
        display: flex;
        border-radius: 79px;
        outline: 1px solid var(--case-btn-border-color);
        width: fit-content;
        min-height: 35px;

        .filter-type {
          height: 35px;
          position: relative;
          z-index: 2;
          transition: outline 0.3s, color 0.3s;
          border: none;
          border-radius: 79px;
          outline: 1px solid transparent;
          width: 144px;
          padding: 5px 16px;
          background-color: transparent;
          font-size: 14px;
          font-weight: 600;
          line-height: 14px;
          color: var(--light-gray);
        }

        .filter-type.selected {
          outline: 1px solid var(--accent-color);
          color: var(--accent-color);
        }

        .filter-type:hover {
          color: var(--accent-color);
        }
      }

      .advanced-change-button-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;

        .add-to-favorites {
          margin-right: 23px;
        }

        .advanced-change-button {
          height: 30px;
          display: flex;
          align-items: center;
          border: none;
          outline: none;
          padding: 0;
          background-color: unset;

          span {
            margin: 0 6px;
            font-weight: 500;
            font-size: 14px;
            line-height: 17px;
            color: #373C44;
          }

          &:hover span {
            text-decoration: underline;
          }

          .advanced-mode {
            fill: var(--accent-color);

            &-arrow {
              transform: rotate(180deg);
            }
          }
        }

        .reset-filters {
          background-color: transparent;
          display: flex;
          align-items: center;
          border: none;
          margin-right: 23px;
          padding: 0;
          font-weight: 500;
          font-size: 14px;
          color: var(--secondary-black-color);
        }

        .reset-filters:disabled path {
          fill: var(--case-btn-border-color);
        }

        .reset-filters:disabled {
          cursor: not-allowed;
        }

        .reset-filters svg {
          margin-right: 10px;
        }

        .reset-filters:not(:disabled):hover {
          text-decoration: underline;
        }
      }

      .timer {
        padding: 20px 0 0 20px;

        span {
          font-size: 14px;
          font-weight: 500;
          line-height: 17px;
          color: var(--secondary-text-color);
        }
      }
    }

    .advanced-filter-wrap {
      width: 100%;
      margin-top: 20px;
      position: relative;

      .advanced-change-button {
        height: 30px;
        display: flex;
        align-items: center;
        border: none;
        outline: none;
        padding: 0;
        background-color: unset;

        span {
          margin: 0 6px;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          color: #373C44;
        }

        &:hover span {
          text-decoration: underline;
        }

        .advanced-mode {
          fill: var(--accent-color);

          &-arrow {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .holder-table {
    margin-top: 50px;

    h1 {
      font-size: 14px;
      font-weight: 700;
      line-height: 21px;
      letter-spacing: 0.03em;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      text-transform: uppercase;
      color: var(--light-gray);
      margin: 0 0 15px;
    }
  }
}

.removed path {
  fill: #ff9537;
}

.control-tags {
  margin-bottom: 0;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-tag {
  display: flex;
  align-items: center;
  width: max-content;
  padding: 6px 12px;
  border-radius: 20px;
  background-color: var(--accent-color);
  font-size: 13px;
  color: var(--white-color);

  button {
    display: flex;
    margin-right: 8px;
    border: navajowhite;
    padding: 0;
    background-color: unset;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  path {
    transition: fill 0.3s;
  }

  strong {
    text-transform: capitalize;
  }

  &s-close {
    display: flex;
    align-items: center;
  }

  &s-arrow {
    transition: all 0.3s;
  }
}


.filtering-name b {
  color: red;
}

.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 25px 0 0;
  display: block;
  width: 100%;
}

.dialog-create-description {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  color: var(--light-gray);
  margin: 10px 0 0;
}

.progress-bar {
  width: 345px;
  background-color: #EBEFF6;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 30px 30px;
}

.progress {
  height: 5px;
  background-color: var(--accent-color);
  width: 0;
  transition: width 0.3s;
}

</style>
